import React from 'react'

import { Dropdown as AntDropdown } from 'antd'
import PropTypes from 'prop-types'

import { getWrapperContainer } from './Select'

export const Dropdown = props => {
  let { getPopupContainer } = props

  if (getPopupContainer == null) {
    getPopupContainer = getWrapperContainer
  }

  return <AntDropdown {...props} getPopupContainer={getPopupContainer} />
}

Dropdown.propTypes = {
  getPopupContainer: PropTypes.func,
}

Dropdown.defaultProps = {
  getPopupContainer: null,
}
